
import { cn } from "@/lib/utils";
import { ContentCard } from "../content-card";
import { ContentItem } from "../content-card/types";
import FrameCard from "./FrameCard";

interface ContentFrameProps {
  contentItems: ContentItem[];
  onContentClick: (id: string) => void;
  onDeleteContent: (id: string) => void;
  onEditContent?: (id: string, currentTitle: string) => void;
  onArchiveContent?: (id: string) => void;
  collectionColor?: string | null;
}

const ContentFrame = ({ 
  contentItems, 
  onContentClick, 
  onDeleteContent, 
  onEditContent,
  onArchiveContent,
  collectionColor
}: ContentFrameProps) => {
  console.log('[FRAME DEBUG] ContentFrame rendering with:', {
    itemsCount: contentItems.length,
    onEditContentExists: typeof onEditContent === 'function',
    collectionColor
  });
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-6">
      {contentItems.length === 0 ? (
        <div className="col-span-full text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
          <p className="text-gray-500">No content items available</p>
        </div>
      ) : (
        contentItems.map((item) => {
          // Use collection color if provided, otherwise use item's collection color, or default
          const itemColor = item.collection_color || collectionColor || "#6B7789";
            
          console.log(`[FRAME DEBUG] ContentFrame - Rendering FrameCard for item ${item.id}`, { 
            itemId: item.id,
            itemTitle: item.title,
            itemColor,
            itemOwnColor: item.collection_color,
            collectionColor
          });
          
          const handleCardClick = () => {
            console.log(`[FRAME DEBUG] ContentFrame - Card clicked: ${item.id} (${item.title})`);
            onContentClick(item.id);
          };
          
          return (
            <div key={item.id} className="w-full">
              <FrameCard
                key={item.id}
                item={{
                  ...item,
                  collection_color: itemColor
                }}
                onClick={handleCardClick}
                onDelete={onDeleteContent}
                onEdit={onEditContent}
                onArchive={onArchiveContent}
              />
            </div>
          );
        })
      )}
    </div>
  );
};

export default ContentFrame;
